import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setLanguage } from '@store/slices/common.slice';
import { useBrowserLanguage } from '@hooks';
import { Logo } from '@components/common';
import { Box } from '@mui/material';

export const AuthLayout: FC = ({ children }) => {
	const dispatch = useDispatch();
	const lang = useBrowserLanguage();

	useEffect(() => {
		dispatch(setLanguage(lang))
	}, [lang]);


	return (
		<Box sx={{ width: 1.0, height: 1.0, overflow: 'hidden', display: 'flex', flexDirection: 'column', position: 'relative' }}>
			<Logo
				sx={{
					position: { xs: 'initial', md: 'absolute' },
					top: { xs: 'unset', md: 21 },
					left: { xs: 'unset', md: 68 },
					transform: { xs: 'unset', md: 'translateX(0)' },
					justifyContent: { xs: 'center', md: 'unset' },
					marginY: { xs: 2, md: undefined }
				}}
			/>
			{children}
		</Box>
	);
};
